import { FC } from 'react';
import { useCoresPainel } from '@/components/paineis/chartTheme';
import PainelShell from '@/components/paineis/PainelShell';
import PainelDre from '@/components/paineis/dre/PainelDre';
import { usePainelFiltrado } from '@/hooks/usePainelFiltrado';
import { dashboardsService } from '@/services/dashboards.service';
import type { DrePayload } from '@/types/dashboards';

const buscarDre = (params: Record<string, string>) => dashboardsService.getEquiplexDre(params);

/**
 * DRE e desvios P&L da Equiplex (`/paineis/equiplex/dre`) — a DRE do Manus com o contábil
 * do Datasul, na classificação do próprio ERP, com orçado do BGC e comparação mês a mês.
 * Projetado e Otimista ficam de fora: só existem na planilha, e o painel não aceita upload.
 * Do filtro dos painéis, só o período vale (pelos meses comuns inteiros que ele toca).
 */
const EquiplexDrePage: FC = () => {
  const cores = useCoresPainel();
  const { estado, barra } = usePainelFiltrado<DrePayload>(buscarDre);
  return (
    <PainelShell
      estado={estado}
      prefixo="dre"
      origem="dre"
      titulo="DRE e desvios P&L"
      subtitulo="Contábil do Datasul na classificação do próprio ERP, mês a mês, contra o orçado e a média dos últimos meses."
      corte={(p) => p.corte}
    >
      {({ id, payload }) => (
        <>
          {barra(payload.recorte, payload.filtro_nao_se_aplica)}
          <PainelDre key={id} payload={payload} cores={cores} />
        </>
      )}
    </PainelShell>
  );
};

export default EquiplexDrePage;
